export class FlowManagerUtil {
  static convertToPathWithoutFlowId(fullPath: string) {
    const index = fullPath.lastIndexOf('/');
    let pathWithoutFlowId = '';
    if (index > -1) {
      pathWithoutFlowId = fullPath.slice(0, index + 1);
    }
    return pathWithoutFlowId;
  }

  static sanitizeFlowName(flowName: string) {
    const index = flowName.lastIndexOf('/');
    let cleanFlowName = flowName;
    if (index > -1) {
      cleanFlowName = flowName.slice(index + 1);
    }
    return cleanFlowName;
  }
}
